module.exports = __webpack_public_path__ + "img/iconPlay.1cd9b25e.png";